module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/download-icon-88a02bf5263a0cb36192ebc729c634c0.svg&quot;;"